<template>
    <div>
        <div class="page-breadcrumb">
            <div class="row">
                <div class="col-5 align-self-center">
                    <h4 class="page-title"><i class="fas fa-warehouse"></i> Warehouses</h4>
                    <div class="d-flex align-items-center">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <router-link :to="{name: 'dashboard'}">Home</router-link>
                                </li>
                                <li class="breadcrumb-item active" aria-current="page">
                                    <strong>Warehouses</strong>
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <div class="col-7 align-self-center">
                    <div class="d-flex no-block justify-content-end align-items-center">
                        <router-link :to="{name: 'addWarehouse', params: {marketplaceid: currentOrg.marketplace_id}}" class="btn btn-success waves-effect waves-light text-white">
                            <i class="fas fa-plus"></i>&nbsp; New Warehouse
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "WarehousesLayout",
        computed: {
            ...mapGetters(["currentOrg"])
        }
    }
</script>

<style scoped>

</style>
